import { SVGProps } from "react";

export default function CaCheckMark(props: SVGProps<never>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <circle cx="10" cy="10" r="10" fill="#74DFAC" />
      <path
        d="M6.04688 12.2297L8.01328 13.822C8.13879 13.9236 8.29581 13.9689 8.45155 13.9485C8.60728 13.9281 8.74967 13.8435 8.84899 13.7124L13.9539 6.97656"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
}
